"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initTimezone = exports.initCity = exports.getTimezoneByCityId = exports.getDiff = exports.prettyUnit = exports.FormatDateTimeInfo = exports.getInitCountry = exports.getIntervalPattern = exports.getCountryTimezone = exports.getDuration = exports.date2str = exports.createDateTimeFormatter = exports.getFormat = exports.getBaseInfo = exports.getTimezone = exports.getOffsetTime = exports.getOffset = exports.checkoutTimestamp = exports.cusFormatDate = exports.matchTime = exports.initBase = exports.DateFormat = void 0;
var __1 = require("..");
var constants_1 = require("../utils/constants");
var variableLocal = function () {
    if (!__1.Config.locale) {
        throw Error('Elvish Error: please call init const with local parameter first');
    }
};
var DateFormat = /** @class */ (function () {
    function DateFormat() {
    }
    DateFormat.init = function (config) {
        var cityMap = config.cityMap, countryTimezone = config.countryTimezone, timezone = config.timezone;
        DateFormat.cityMap = cityMap;
        DateFormat.countryTimezone = countryTimezone;
        DateFormat.timeZone = timezone;
        DateFormat.inited = true;
        DateFormat.timeZoneList = timezone;
    };
    return DateFormat;
}());
exports.DateFormat = DateFormat;
var initBase = function (config, errMsg) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        DateFormat.init(config);
        return [2 /*return*/, new Promise(function (resolve) {
                resolve(errMsg || '');
            })];
    });
}); };
exports.initBase = initBase;
var matchTime = function (pattern, time) {
    var matchFn = function (reg) {
        var matched = pattern.match(new RegExp(reg));
        if (reg === 'a') {
            return matched ? time.substr(matched.index, time.length - 1) : '';
        }
        return matched ? time.substr(matched.index, matched[0].length) - (reg === 'M+' ? 1 : 0) : 0;
    };
    return {
        year: matchFn('y+'),
        month: matchFn('M+'),
        day: matchFn('d+'),
        hour: matchFn('H+'),
        minute: matchFn('m+'),
        second: matchFn('s+')
    };
};
exports.matchTime = matchTime;
// 将传入的日期对象格式化为特定的字符串格式
var cusFormatDate = function (date) {
    var year = date.getFullYear();
    var month = (date.getMonth() + 1).toString().padStart(2, '0');
    var day = date.getDate().toString().padStart(2, '0');
    var hours = date.getHours().toString().padStart(2, '0');
    var minutes = date.getMinutes().toString().padStart(2, '0');
    var seconds = date.getSeconds().toString().padStart(2, '0');
    return "".concat(year, "/").concat(month, "/").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
};
exports.cusFormatDate = cusFormatDate;
var checkoutTimestamp = function (timestamp) {
    if (!Number.isInteger(Number(timestamp))) {
        console.warn('Elvish Warning: timestamp must be Integer');
    }
    if (String(timestamp).length !== 10) {
        console.warn('Elvish Warning: timestamp must be 10 digits');
    }
    if (Number(timestamp) - DateFormat.timeZone.offset < 0) {
        console.warn("Elvish Warning: timestamp must be greater than or equal to ".concat(DateFormat.timeZone.offset));
    }
};
exports.checkoutTimestamp = checkoutTimestamp;
var getOffset = function (timeStamp, timezone) {
    var timeZoneData = DateFormat.timeZone.timezones[timezone || DateFormat.curTimeZone];
    if (!timeZoneData) {
        throw Error("Elvish Error: invalid timezone parameters");
    }
    var interval = timeZoneData.interval, offset = timeZoneData.offset, mapping = timeZoneData.mapping;
    var index = interval.findIndex(function (intervalValue, idx) {
        return timeStamp - DateFormat.timeZone.offset >= intervalValue &&
            timeStamp - DateFormat.timeZone.offset < interval[idx + 1];
    });
    // 如果找不到 index，说明关于该时区的 interval 配置不包含在现有的时间戳范围内，配置有问题
    if (index === -1) {
        throw Error("Elvish Error: the timestamp did not find a suitable index in the interval");
    }
    return offset[mapping[index] * 2] + offset[mapping[index] * 2 + 1];
};
exports.getOffset = getOffset;
var getOffsetTime = function (timeStamp, timezone) {
    variableLocal();
    return timeStamp + (0, exports.getOffset)(timeStamp, timezone);
};
exports.getOffsetTime = getOffsetTime;
var getTimezone = function (cityId) {
    return cityId ? DateFormat.cityMap[cityId] : DateFormat.curTimeZone;
};
exports.getTimezone = getTimezone;
var getBaseInfo = function () {
    variableLocal();
    return {
        locale: __1.Config.locale
    };
};
exports.getBaseInfo = getBaseInfo;
var getDateTime = function () {
    var _a, _b, _c;
    variableLocal();
    var dateTime = ((_a = __1.Config.apollo) === null || _a === void 0 ? void 0 : _a.datetime[__1.Config.locale]) || ((_b = __1.Config.apollo) === null || _b === void 0 ? void 0 : _b.datetime.default);
    if (dateTime.alias)
        dateTime = (_c = __1.Config.apollo) === null || _c === void 0 ? void 0 : _c.datetime[dateTime.alias];
    return dateTime;
};
var getFormat = function (offsetTime, dateStyle, timeStyle) {
    variableLocal();
    var map = [
        'TIME_HH_MM_SS',
        'TIME_HH_MM',
        'DATE_DD_MM_YYYY',
        'DATE_DD_MM_YY',
        'DATE_MTH_YYYY',
        'DATE_EEE_DD_MTH',
        'DATE_DD_MTH',
        undefined,
        'DATE_NONE',
        'TIME_NONE'
    ];
    var dateTimePatterns = getDateTime().dateTimePatterns;
    var getAmPm = function () {
        try {
            var date = new Intl.DateTimeFormat(__1.Config.locale, {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                hour12: true
            });
            return date === null || date === void 0 ? void 0 : date.format(offsetTime * 1000).match(/\s\S+$/)[0].replace(/\s/, '');
        }
        catch (e) {
            return '';
        }
    };
    return {
        dateFormat: dateTimePatterns[map.indexOf(dateStyle)],
        timeFormat: dateTimePatterns[map.indexOf(timeStyle)],
        format: dateTimePatterns[dateTimePatterns.length - 1],
        amPmMarkers: getDateTime().amPmMarkers || getAmPm(),
        offsetTime: offsetTime
    };
};
exports.getFormat = getFormat;
var createDateTimeFormatter = function (locales, options) {
    var formatter = new Intl.DateTimeFormat(locales, options);
    // See https://github.com/GoogleChrome/lighthouse/issues/1056
    var tz = formatter.resolvedOptions().timeZone;
    if (!tz || tz.toLowerCase() === 'etc/unknown') {
        options.timeZone = 'UTC';
        // 强制使用utc，如果runtime timezone不能被识别，可能有潜在bug
        return new Intl.DateTimeFormat(undefined, options);
    }
    return formatter;
};
exports.createDateTimeFormatter = createDateTimeFormatter;
var getPatternMap = function (_a) {
    var time = _a.time, locale = _a.locale, timeStamp = _a.timeStamp;
    var getFormat = function (object) {
        return new Intl.DateTimeFormat('en-GB', __assign({ timeZone: 'UTC', hour12: false }, object)).format(time);
    };
    var getFormatWeek = function (object) {
        return new Intl.DateTimeFormat(locale, __assign({ timeZone: 'UTC', hour12: false }, object)).format(time);
    };
    var hour = Number(getFormat({
        hour: 'numeric'
    }));
    // 西语国家，月份缩写小写
    var isEs = (locale || '').toLowerCase().includes('es') || false;
    var shortMounth = getFormatWeek({ month: 'short' });
    var patternMap = {
        M: getFormat({
            month: 'numeric'
        }),
        d: getFormat({
            day: 'numeric'
        }),
        H: hour,
        m: getFormat({
            minute: 'numeric'
        }),
        s: getFormat({
            second: 'numeric'
        }),
        y: getFormat({
            year: 'numeric'
        }),
        h: hour === 0 ? 12 : hour > 12 ? hour - 12 : hour,
        S: getFormat({
            fractionalSecondDigits: 3
        }),
        MMM: isEs ? shortMounth.toLowerCase() : shortMounth,
        E: getFormatWeek({
            weekday: 'short'
        }),
        EEEE: getFormatWeek({
            weekday: 'long'
        })
    };
    return patternMap;
};
// amPmMarkers 上下午标记
var date2str = function (_a) {
    var locale = _a.locale, timeStamp = _a.timeStamp, pattern = _a.pattern, amPmMarkers = _a.amPmMarkers, curOffset = _a.curOffset;
    var curPattern = !amPmMarkers ? pattern.replace(/h/g, 'H') : pattern;
    var time = !(timeStamp instanceof Date) ? new Date(timeStamp * 1000) : timeStamp;
    var patternMap = getPatternMap({
        locale: locale,
        time: time,
        timeStamp: timeStamp
    });
    var result = curPattern === null || curPattern === void 0 ? void 0 : curPattern.replace(/(E+|M+|d+|H+|h+|m+|s+|S+|y+|a|'[a-z]+')/g, function (v) {
        if (/'[a-z]+'/.test(v))
            return v.replace(/'/g, '');
        if (/a/.test(v))
            return amPmMarkers instanceof Array ? amPmMarkers[~~(patternMap.H > 11)] : amPmMarkers;
        var key = v === 'EEEE' || v === 'MMM' ? v : v.slice(-1);
        var patternToString = patternMap[key]
            .toString()
            .slice(-(v.length > 2 ? patternMap[key].length : 2));
        if (patternToString.length < v.length && /^\d+$/.test(patternToString))
            patternToString = patternToString.padStart(v.length, '0');
        return patternToString;
    });
    return result;
};
exports.date2str = date2str;
var getDuration = function (seconds) {
    var duration = getDateTime().duration;
    var DAY_IN_SECONDS = 3600 * 24;
    var HOUR_IN_SECONDS = 3600;
    var MINUTE_IN_SECONDS = 60;
    // 天
    if (seconds >= DAY_IN_SECONDS) {
        return seconds % DAY_IN_SECONDS === 0 || seconds < DAY_IN_SECONDS + HOUR_IN_SECONDS
            ? duration[3]
            : duration[6];
    }
    // 小时
    if (seconds >= HOUR_IN_SECONDS) {
        return seconds % HOUR_IN_SECONDS === 0 || seconds < HOUR_IN_SECONDS + MINUTE_IN_SECONDS
            ? duration[2]
            : duration[5];
    }
    // 分钟
    if (seconds >= MINUTE_IN_SECONDS) {
        return seconds % MINUTE_IN_SECONDS === 0 || seconds === MINUTE_IN_SECONDS
            ? duration[1]
            : duration[4];
    }
    return duration[0];
};
exports.getDuration = getDuration;
var getCountryTimezone = function (country) {
    return DateFormat.countryTimezone[country];
};
exports.getCountryTimezone = getCountryTimezone;
// 填充模板语法
var getIntervalPattern = function (startTimeStamp, endTimeStamp, dateStyle, timeStyle) {
    var _a;
    var lrgUnits = ['MONTH', 'DATE', 'HOUR', 'MINUTE', 'SECOND', 'YEAR'];
    var intervalFormats = getDateTime().intervalFormats;
    var startDate = new Date(startTimeStamp * 1000);
    var endDate = new Date(endTimeStamp * 1000);
    var locale = (0, exports.getBaseInfo)().locale;
    var startDates = Object.values(getPatternMap({ time: startDate, locale: locale, timeStamp: startTimeStamp }));
    var endDates = Object.values(getPatternMap({ time: endDate, locale: locale, timeStamp: endTimeStamp }));
    var type;
    var lrgUnit;
    for (var i = 0; i < lrgUnits.length; i++) {
        if (startDates[i] !== endDates[i]) {
            lrgUnit = lrgUnits[i];
            break;
        }
    }
    var timeHHMMError = new Error('Elvish Error: Only the current day is supported when timeStyle is TIME_HH_MM');
    if (lrgUnit === 'YEAR' && timeStyle === 'TIME_HH_MM')
        throw timeHHMMError;
    if (lrgUnit === 'MONTH' && timeStyle === 'TIME_HH_MM')
        throw timeHHMMError;
    if (lrgUnit === 'DATE' && timeStyle === 'TIME_HH_MM')
        throw timeHHMMError;
    if (lrgUnit === 'YEAR' && endDates[0] - startDates[0] > 1)
        throw Error('Elvish Error: Only support across one year');
    if (lrgUnit === 'DATE' && dateStyle === 'DATE_NONE')
        dateStyle = 'DATE_DD_MM_YYYY';
    if ((lrgUnit === 'HOUR' || lrgUnit === 'MINUTE') &&
        dateStyle === 'DATE_DD_MTH' &&
        timeStyle === 'TIME_NONE') {
        dateStyle = 'DATE_NONE';
        timeStyle = 'TIME_HH_MM';
    }
    if (timeStyle === 'TIME_HH_MM') {
        if (dateStyle === 'DATE_DD_MM_YYYY') {
            type = 'YYYYMMDDHHMM';
        }
        else if (dateStyle === 'DATE_DD_MTH') {
            type = 'MMMDDHHMM';
        }
        else if (dateStyle === 'DATE_NONE') {
            type = 'HHMM';
        }
    }
    else {
        type = 'MMMDD';
    }
    var intervalFormatsArr = intervalFormats[type].flatMap(function (one) { return one.dtItvInfos; });
    return (_a = (intervalFormatsArr.find(function (one) { return one.lrgUnit === lrgUnit; }) ||
        intervalFormatsArr.find(function (one) { return one.lrgUnit === '*'; }))) === null || _a === void 0 ? void 0 : _a.intervalPattern;
};
exports.getIntervalPattern = getIntervalPattern;
var getInitCountry = function () {
    return __1.Config.country;
};
exports.getInitCountry = getInitCountry;
var FormatDateTimeInfo = /** @class */ (function () {
    function FormatDateTimeInfo(props) {
        var _a;
        var timeStamp = props.timeStamp, timezone = props.timezone;
        var parsedTimeStamp = parseInt(timeStamp, 10);
        this.locale = (_a = (0, exports.getBaseInfo)()) === null || _a === void 0 ? void 0 : _a.locale;
        this.offsetTime = (0, exports.getOffsetTime)(parsedTimeStamp, timezone);
        var offset = (0, exports.getOffset)(parsedTimeStamp, timezone || (0, exports.getTimezone)()) / 3600;
        this.utcStr = isNaN(offset) ? 'UTC--' : offset >= 0 ? "UTC+".concat(offset) : "UTC".concat(offset);
    }
    FormatDateTimeInfo.prototype.getFormatConf = function () {
        return this.conf;
    };
    FormatDateTimeInfo.prototype.formatConf = function (dateStyle, timeStyle) {
        this.conf = (0, exports.getFormat)(this.offsetTime, dateStyle, timeStyle);
        return this;
    };
    FormatDateTimeInfo.prototype.formatStr = function (format, showOffset, timeStamp) {
        var _a;
        if (!format)
            return '';
        var dateString = (0, exports.date2str)({
            locale: this.locale,
            timeStamp: timeStamp || this.offsetTime,
            pattern: format,
            amPmMarkers: (_a = this.conf) === null || _a === void 0 ? void 0 : _a.amPmMarkers,
            curOffset: this.offsetTime
        });
        return showOffset ? "".concat(dateString, " ").concat(this.utcStr) : dateString;
    };
    return FormatDateTimeInfo;
}());
exports.FormatDateTimeInfo = FormatDateTimeInfo;
var prettyUnit = function (u) {
    return (constants_1.C_DATE[u.toUpperCase()] ||
        String(u || '')
            .toLowerCase()
            .replace(/s$/, ''));
};
exports.prettyUnit = prettyUnit;
var getDiff = function (diffSecond, unit) {
    var convertToUnit = function (seconds, unitInSeconds) {
        return (seconds / unitInSeconds).toFixed(2);
    };
    var oneMinute = 60;
    var oneHour = 60 * oneMinute;
    var oneDay = 24 * oneHour;
    switch (unit) {
        case 'day':
            return convertToUnit(diffSecond, oneDay);
        case 'hour':
            return convertToUnit(diffSecond, oneHour);
        case 'minute':
            return convertToUnit(diffSecond, oneMinute);
        default:
            return diffSecond;
    }
};
exports.getDiff = getDiff;
var getTimezoneByCityId = function (cityId) {
    return (0, exports.getTimezone)(cityId);
};
exports.getTimezoneByCityId = getTimezoneByCityId;
function initCity(cityId) {
    if (!DateFormat.cityMap[cityId])
        throw Error('Elvish Error: cityId is not valid');
    DateFormat.curTimeZone = DateFormat.cityMap[cityId];
}
exports.initCity = initCity;
function initTimezone(timezone) {
    DateFormat.curTimeZone = timezone;
}
exports.initTimezone = initTimezone;
